export default {
  namespaced: true,
  state: {
    msg: "",
    language: process.env.VUE_APP_DEFAULT_LANGUAGE,
    messageUnreadCount: 0 // 未读消息数
  },
  mutations: {
    // 设置父应用信息
    SET_MSG_VALUE(state, data) {
      state.msg = data;
    },
    SET_LANGUAGE(state, data) {
      state.language = data;
    },
    // 设置导航栏未读消息数
    SET_MESSAGE_UNREAD_COUNT: (state, data) => {
      state.messageUnreadCount = data;
    }
  },
  actions: {
    // 设置父应用信息
    setMsg({ commit }, data) {
      commit("SET_MSG_VALUE", data);
    },
    // 设置语言
    setLanguage({ commit }, data) {
      commit("SET_LANGUAGE", data);
    },
    // 设置导航栏未读消息数
    setMessageUnreadCount({ commit }, data) {
      commit("SET_MESSAGE_UNREAD_COUNT", data);
    }
  }
};
